import { Typography, Tag } from "antd";
import { formatDateTime, formatMoney } from "../../utils/formatUtils";

const { Text } = Typography;

function getStatementAmount(record) {
  const income = Number(record?.income || 0);
  const expense = Number(record?.expense || 0);

  if (income > 0) return income;
  if (expense > 0) return expense;
  return 0;
}

function getSourceLabel(sourceType) {
  const sourceMap = {
    BANK_STATEMENT: {
      label: "Ориг",
      color: "blue",
    },
    BANK_REPORT_STATEMENT: {
      label: "Хийсвэр",
      color: "purple",
    },
  };

  return (
    sourceMap[sourceType] || {
      label: sourceType || "-",
      color: "default",
    }
  );
}

export function createStatementCompareColumns(currency) {
  return [
    {
      title: "Эх сурвалж",
      dataIndex: "sourceType",
      key: "sourceType",
      width: 120,
      render: (value) => {
        const source = getSourceLabel(value);
        return <Tag color={source.color}>{source.label}</Tag>;
      },
    },
    {
      title: "Гүйлгээний огноо",
      dataIndex: "transactionDate",
      key: "transactionDate",
      width: 190,
      render: (value) => formatDateTime(value),
    },
    {
      title: "Данс / Банк",
      key: "accountBank",
      width: 220,
      render: (_, record) => {
        const account = record?.bankAccount;
        const bank = record?.bank;

        return (
          <div className="leading-tight">
            <div className="font-medium">{account || "-"}</div>
            <div className="text-xs text-gray-500">
              {bank ? bank.replaceAll("_", " ") : "-"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Харилцагчийн нэр",
      dataIndex: "counterpartyName",
      key: "counterpartyName",
      width: 220,
      render: (value) => (
        <div className="whitespace-normal break-words">
          {value || "-"}
        </div>
      ),
    },
    {
      title: "Харилцагчийн данс",
      dataIndex: "counterpartyAccount",
      key: "counterpartyAccount",
      width: 220,
      render: (value) => value || "-",
    },
    {
      title: "Дүн",
      key: "amount",
      width: 160,
      render: (_, record) => (
        <Text strong>{formatMoney(getStatementAmount(record), currency)}</Text>
      ),
    },
    {
      title: "Утга",
      dataIndex: "transactionDescription",
      key: "transactionDescription",
      width: 260,
      render: (value) => (
        <div className="whitespace-normal break-words">
          {value || "-"}
        </div>
      ),
    },
  ];
}